import React, { useState, useEffect, useRef } from "react";
import styles from "../../../../styles/PaymentNew.module.css";
import { useHistory, useLocation } from "react-router";
import { AxiosInstance, PORTS } from "../../../../utils/apiService";
import { notification } from "antd";
import ButtonComponent from "../../../modules/ReusableComponent/ButtonComponent";
import InputComponent from "../../../modules/ReusableComponent/InputComponent";
import FormErrorText from "../../../modules/ProductManagement/FormErrorText";
import LoadingIndicator from "../../../modules/ReusableComponent/LoadingIndicator";
import BlackLeftArrow from "../../../../assets/images/black_left_arrow.svg";
import SelectComponent from "../../../modules/ReusableComponent/SelectComponent";
import { useParams } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Accordion, Card, Button } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import arrowDown from "../../../../assets/images/arrow_down.svg";
import { isObject, isString, isEqual } from "lodash";
import commonstyles from "../../../../styles/Management_Common.module.css";
import {
  onlyAlphabetsWithSpace,
  phoneRegx,
  passwordReg,
  minChar,
  onlyNumbers,
  minCharwithnospacecount,
  onlyAlphabets,
} from "../../../../utils/RegularExp";
import validationRules from "../../../../utils/validationRules";
import {
  formatServerValidtionErrors,
  runValidationChecks,
} from "../../../../utils";
import TextArea from "../../../modules/ReusableComponent/TextArea";

const reviewData_ = {
  description: "",
  // gallery: [],
  individual: { price: null, quality: null, durability: null },
  rating: null,
  status: 1,
  title: "",
  userName: "",
  adminApprovalStatus: 1,
  // createdAt: new Date(),
};

let stttatus;

export default function PaymentNew() {
  const history = useHistory();
  const [reviewData, setReviewData] = useState(reviewData_);
  const [pricerating, setPriceRating] = useState(null);
  const [qualityrating, setQualityRating] = useState(null);
  const [durabilityrating, setDurabilityRating] = useState(null);
  const [summaryrating, setSummaryRating] = useState(null);
  const [ratingsForm, setRatingsForm] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [productName, setProductName] = useState("");
  const [ratingSummary, setRatingSummary] = useState(0);
  const [ratingPrice, setRatingPrice] = useState(0);
  const [ratingQuality, setratingQuality] = useState(0);
  const [ratingDurability, setratingDurability] = useState(0);

  const [hover, setHover] = useState(null);
  let { id } = useParams();
  let location = useLocation();

  const rules = {
    userName: [(val, data) => (!val ? "Username " : true)],
    status: [(val, data) => (!val ? "Status " : true)],
    title: [(val, data) => (!val ? "Summary " : true)],
    description: [(val, data) => (!val || val.length < 3 ? "Description " : true)],
  };

  useEffect(() => {
    getReviewDetail();
  }, []);

  function submit() {
    // let clonedData = ratingsForm;

    // delete clonedData.filter((gallery) => delete gallery.key);
    // delete clonedData.filter((gallery) => delete gallery.orderId);
    // delete clonedData.filter((gallery) => delete gallery.isChecked);
    // delete clonedData.filter((gallery) => delete gallery.userId);
    // delete clonedData.filter((gallery) => delete gallery.createdAt);
    // delete clonedData.filter((gallery) => delete gallery.gallery);

    // if (clonedData.filter((item) => item.status == 0)) {
    //   clonedData.map((item) => (item.status = 0));
    // }

    // clonedData = clonedData.map((itm) => {
    //   if (clonedData) {
    //     return itm;
    //   } else {
    //     itm.status = 1;
    //     return itm;
    //   }
    // });

    // [{1,2,3,4}]

    // clonedData.filter((item) => (item.status = stttatus));

    // delete location.state.ratingsForm.filter((userId) => delete userId.userId);

    // delete location.state.ratingsForm.filter(
    //   (createdAt) => delete createdAt.createdAt
    // );

    reviewData.status = 1;

    reviewData.adminApprovalStatus = 1;

    reviewData.rating = ratingSummary;

    // clonedData.push(reviewData);

    // let dataArray = location.state.ratingsForm;

    let data = {
      productId: id,
      reviews: reviewData,
    };
    // const result = validate(undefined, data.reviews);

    const result = runValidationChecks(rules, undefined, { ...reviewData });

    // console.log(result);

    if (Object.keys(result).length) {
      setFormErrors(result);
      showNotification({
        type: "warning",
        message: "There were few errors",
        description: Object.values(result) + "is required",
      });
      return;
    }
    if (
      reviewData?.userName?.trim().length < 3 ||
      reviewData?.userName?.trim().length > 15
    ) {
      showNotification({
        type: "warning",
        message: "There were few errors",
        description:
          "Username must be more than 2 characters and less than 15 characters",
      });
      return;
    }
    if (
      reviewData.title.trim().length < 3 ||
      reviewData.title.trim().length > 30
    ) {
      showNotification({
        type: "warning",
        message: "There were few errors",
        description:
          "Summary must be more than 2 characters and less than 30 characters",
      });
      return;
    }
    // if (!url) {
    //   showNotification({
    //     type: "warning",
    //     message: "There were few errors",
    //     description: "Please select banner image",
    //   });
    //   return;
    // }

    if (reviewData.description.trim().length < 3) {
      showNotification({
        type: "warning",
        message: "There were few errors",
        description: "Description must be more than 2 characters ",
      });
      return;
    }

    const apiEndPoint = "products/updateReview";

    AxiosInstance(PORTS.INVOICE)
      .post(apiEndPoint, data)
      .then((res) => {
        if (res.data.status === 200) {
          showNotification({
            type: "success",
            message: "Success",
            description: "Reviews added successfully",
          });
          history.push(`/rating`);
        } else {
          showNotification({
            type: "error",
            message: "Error",
            description: "Please fill all mandatory fields",
          });
        }
      })
      .catch((er) => {
        return er;
      });
  }

  function showNotification({ type, message, description }) {
    let options = {
      message: message || "Message",
      description: description,
      duration: 5,
    };
    notification[type](options);
  }

  /**
   * @author Mithun Prabhu
   * @param {}
   * GET ALL REVIEW DETAILS AND SETTING STATE SEPERATELY
   */
  function getReviewDetail() {
    AxiosInstance(PORTS.INVOICE, "application/json")
      .get(`products/reviewDetailofProduct/${id}`)
      .then((res) => {
        // setReviewId(res.data.data.map((review) => review.reviews[0]._id));
        if (res && res.data && res.status == "200") {
          setProductName(res.data.data[0].name);
          setRatingsForm(res.data.data[0].reviews);
        }
      })
      .catch((er) => {
        const data = { type: "error" };
        if (er.response) {
          data.message = "Error";
          data.description = "Failed to get data";

          showNotification(data);
        }
      })
      .finally(() => { });
  }

  /**
   * @author Mithun Prabhu
   * @param {EVENT}
   * CHANGES IN VALUES AND SETTINGS ERROR
   */
  function reviewHandler(e) {
    const { value, name } = e.target;
    const cloneReviewData = { ...reviewData };
    //sread all formErrors and set in cloneformErrors in the end
    const cloneformErrors = { ...formErrors };
    if (name === "userName" && !minChar.test(value)) {
      cloneformErrors.userName = "Enter minimum 3 characters";
    } else if (name === "userName") {
      cloneformErrors.userName = "";
    }

    if (name === "title" && !minChar.test(value)) {
      cloneformErrors.title = "Enter minimum 3 characters";
    } else if (name === "title") {
      cloneformErrors.title = "";
    }

    if (name === "description" && !minChar.test(value)) {
      cloneformErrors.description = "Enter minimum 3 characters";
    } else if (name === "description") {
      cloneformErrors.description = "";
    }

    if (["description"].includes(name) && value?.trim()) {
      cloneReviewData[name] = value;
    } else if (name === "description") {
      cloneReviewData[name] = "";
    }

    if (["title", "userName"].includes(name) && value?.trim()) {
      cloneReviewData[name] = value;
    } else if (name === "title" || name === "userName") {
      cloneReviewData[name] = "";
    }

    setReviewData(cloneReviewData);
    if (["status"].includes(name)) {
      reviewData[name] = parseInt(value);
      stttatus = parseInt(value);
    }
    setFormErrors(cloneformErrors);
  }

  function handlePrice(rate) {
    let result = rate / 20;
    reviewData.individual.price = result;
    let overall = (result + qualityrating + durabilityrating) / 3;
    setRatingSummary(overall);
    setPriceRating(result);
  }

  function handleQuality(rate) {
    let result = rate / 20;
    reviewData.individual.quality = result;
    let overall = (pricerating + result + durabilityrating) / 3;
    setRatingSummary(overall);
    setQualityRating(result);
  }

  function handleDurability(rate) {
    let result = rate / 20;
    reviewData.individual.durability = result;
    let overall = (pricerating + qualityrating + result) / 3;
    setRatingSummary(overall);
    setDurabilityRating(result);
  }

  return (
    <div className={styles.management_contents}>
      <div className={styles.management_header}>
        <h1>
          <img
            src={BlackLeftArrow}
            alt=""
            className="cursor-pointer"
            onClick={() => history.push(`/rating/${id}`)}
          />
          Add Review
        </h1>
        <div className={styles.management_contents_upload}>
          {/* <button className={`btn ${styles.btn_filled}`}>Save</button> */}
        </div>
      </div>

      <div className={styles.management_details}>
        <div className={styles.management_details_contents}>
          <label className="mb-4">
            Product
            <a className={styles.management_product_link}>{productName}</a>
          </label>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className={styles.management_details_form}>
                <label for="">
                  Username
                  <span
                    className="text-danger top-10"
                    style={{ fontSize: "20px" }}
                  >
                    *
                  </span>
                </label>
                <InputComponent
                  className={`form-control form-control-lg ${styles.form_control}`}
                  error={formErrors.userName}
                  formControl={{
                    name: "userName",
                    value: reviewData?.userName,
                    onChange: (e) => reviewHandler(e),
                    maxLength: "30",
                  }}
                />
                <FormErrorText error={formErrors.userName} />
              </div>
            </div>
            {/* <div className="col-lg-6 mb-4">
              <div className={styles.management_details_form}>
                <label for="">
                  Status
                  <span className="text-danger" style={{ fontSize: "20px" }}>
                    *
                  </span>
                </label>
                <SelectComponent
                  className={`form-control form-control-md ${styles.form_control}`}
                  error={formErrors.status}
                  attributes={{
                    name: "status",
                    onChange: reviewHandler,
                  }}
                >
                  <option>Update State</option>
                  <option value="1">Approve</option>
                  <option value="2">Reject</option>
                </SelectComponent>
                <FormErrorText error={formErrors.status} />
              </div>
            </div> */}
          </div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className={styles.management_details_form}>
                <label for="">
                  Author
                  <span
                    className="text-danger top-10"
                    style={{ fontSize: "20px" }}
                  >
                    *
                  </span>
                </label>
                <InputComponent
                  className={`form-control form-control-lg ${styles.form_control}`}
                  formControl={{
                    placeholder: "",
                    name: "author",
                    value: localStorage.getItem("roleName"),
                    // onChange: (e) => reviewHandler(e),
                  }}
                />
                <FormErrorText />
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className={styles.management_details_form}>
                <label for="">
                  Summary of review
                  <span
                    className="text-danger top-10"
                    style={{ fontSize: "20px" }}
                  >
                    *
                  </span>
                </label>
                <InputComponent
                  className={`form-control form-control-lg ${styles.form_control}`}
                  error={formErrors.title}
                  formControl={{
                    placeholder: "",
                    name: "title",
                    value: reviewData?.title,
                    onChange: reviewHandler,
                    maxLength: "30",
                  }}
                />
                <FormErrorText error={formErrors.title} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div id="accordion">
                <Accordion defaultActiveKey="0">
                  <Card
                    className={`${styles.accordion_rating_rating_card} br-10`}
                  >
                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                      <Card.Header
                        className={`${styles.accordion_rating_card_header}`}
                      >
                        <div className={styles.management_details_form}>
                          <label
                            for=""
                            className={`${styles.accordion_rating_title}`}
                          // style={{ padding: 0 }}
                          >
                            Summary Rating
                            <img
                              src={arrowDown}
                              className={`${styles.accordion_rating_arrow}`}
                              alt="arrow"
                            />
                          </label>

                          {[...Array(1)].map((star, indx) => {
                            return (
                              <Rating
                                readonly={true}
                                size={30}
                                name="rating"
                                // onClick={handleRating}
                                initialValue={
                                  ratingSummary
                                } /* Available Props */
                              />
                            );
                          })}
                        </div>
                      </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body
                        className={`${styles.accordion_rating_card_body}`}
                      >
                        <div
                          className={`${styles.management_details_form} mb-4`}
                        >
                          <label for="">Price </label>
                          {[...Array(1)].map((star, indx) => {
                            return (
                              <Rating
                                size={30}
                                onClick={handlePrice}
                                name="price"
                                ratingValue={ratingPrice} /* Available Props */
                              />
                            );
                          })}
                        </div>

                        <div
                          className={`${styles.management_details_form} mb-4`}
                        >
                          <label for="">Quality </label>
                          {[...Array(1)].map((star, indx) => {
                            return (
                              <Rating
                                size={30}
                                name="quality"
                                onClick={handleQuality}
                                ratingValue={
                                  ratingQuality
                                } /* Available Props */
                              />
                            );
                          })}
                        </div>
                        <div
                          className={`${styles.management_details_form} mb-4`}
                        >
                          <label for="">Durability </label>
                          {[...Array(1)].map((star, indx) => {
                            return (
                              <Rating
                                size={30}
                                onClick={handleDurability}
                                name="durability"
                                ratingValue={
                                  ratingDurability
                                } /* Available Props */
                              />
                            );
                          })}
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-4">
              <div className={styles.management_details_form}>
                <label for="">
                  Description
                  <span
                    className="text-danger top-10"
                    style={{ fontSize: "20px" }}
                  >
                    *
                  </span>
                </label>
                <TextArea
                  className={`${commonstyles.form_control} form-control form-control-lg `}
                  error={formErrors.description}
                  formControl={{
                    name: "description",
                    value: reviewData?.description,
                    placeholder: "Type your description",
                    rows: 4,
                    onChange: (e) => reviewHandler(e),
                  }}
                />
                <FormErrorText error={formErrors.description} />
              </div>
            </div>
            <div className={`${styles.btn_section} col-lg-12`}>
              <a className={`${styles.rating_btn} btn`} onClick={submit}>
                Save review
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </div>
  );
}
